import DatePicker from 'material/DatePicker'

import { FORM_TEXT } from '../ExtensionModal'
import type { formVals } from '../ExtensionModal'
type props = {
  formValues: formVals
  handleInputsChange: (name: string, value: string | Date | number) => void
  maxDate: Date | string | number
  minDate: Date | string | number
}
const ExtensionDatePicker = ({ formValues, handleInputsChange, maxDate, minDate }: props) => {
  return (
    <DatePicker
      required
      disabled={formValues.deadlineId ? false : true}
      date={formValues.extensionDate ?? ''}
      onChange={(value: string | Date | number) => handleInputsChange('extensionDate', value)}
      label={FORM_TEXT.dateLabel}
      id="extensionDate"
      format="MM/dd/yyyy"
      placeholder="MM/DD/YYYY"
      minDateMessage={FORM_TEXT.dateMinError}
      maxDateMessage={FORM_TEXT.dateMaxError}
      invalidDateMessage={FORM_TEXT.dateHelper}
      maxDate={maxDate}
      minDate={minDate}
      disablePast
      autoOk
    />
  )
}

export default ExtensionDatePicker
